<script>
  import { layoutMethods, digitalLoadMethods, exportMethods, erpFixMessages} from "@/state/helpers";
  import Swal from 'sweetalert2';
  import { getModuleAccess, showAccessRestrictedModal } from '@/router/helper.js'

  /**
   * E-Load Provider List component
   */
  export default {
    page: {
      title: "E-Load Provider List"
    },
    components: {
    },
    computed: {
      ...erpFixMessages
    },
    data() {
      return {
        title: "E-Load Provider",
        searchValue: {
            search: null,
            searchField: null,
            page: 1,
            rows: 10,
            sort: 'id',
            orderDesc: true,
            status: null,
        },
        searchOptions: [
          { text: 'Search All', value: null },
          { text: 'Provider Name', value: "provider_name" },
          { text: 'API Endpoint', value: "api_endpoint" },
        ],
        fields: [
          { key: "action", label: "Action", sortable: false},
          { key: "provider_name", label: "Provider Name", sortable: true},
          { key: "api_endpoint", label: "API Endpoint", sortable: true},
          { key: "status", label: "Status", sortable: true},
          { key: "on_sku_level", label: "Sku Level", sortable: true},
          { key: "front_margin", label: "Front Margin Rebate %", sortable: true},
          { key: "back_margin", label: "Back Margin Rebate %", sortable: true},
          { key: "total_margin", label: "Total Margin Rebate %", sortable: true},
        ],
        statusOption:[{"value": null,"text":"All"},{"value": 'a',"text":"Active"},{"value": 'i',"text":"Inactive"}],
        totalRecord: 0,
        listRecord:[],
        sortBy: "id",
        sortDesc: true,
        pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
        eloadProviderModule: {
          access: {
            create: false,
            read: false,
            update: false,
            delete: false
          }
        },
      };
    },
    methods: {
      ...layoutMethods,
      ...digitalLoadMethods,
      ...exportMethods,
      addEloadProvider(){
        this.$router.push(
          this.$route.query.redirectFrom || {
            name: "E-Load Provider Form", params: { id: 0}
          }
        );
      },
      refresh(){
        this.onSearch();
      },
      async onSearch(state=''){
        if(state == 'reset'){
          this.searchValue.page = 1;
        }
        await this.actionProvider({
            action: "list",
            body: this.searchValue
        })
        .then((res) => {
          this.totalRecord =res["message"]["pageInfo"]["total"] 
          this.listRecord = res["message"]["rows"]
          console.log(res);
        }).catch((e)=>{
          console.log("error while getting list",e);
        });
      },
      tableSorting(ctx){//context
        this.searchValue.sort = ctx.sortBy;
        this.searchValue.orderDesc = ctx.sortDesc;
        this.onSearch('reset');
      },
      deleteProvider(item){
        if (this.eloadProviderModule.access.delete) {
          Swal.fire({
              title: 'Are you sure?',
              text: `Do you really want to delete ${item.provider_name}? This process cannot be undone.`,
              icon: 'question',
              showCancelButton: true,
              confirmButtonColor: '##804997',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No'
          }).then((result) => {
              if (result.isConfirmed) {
                this.actionProvider({
                    action: "delete",
                    body: {"provider_id":item.id}
                })
                .then((res) => {
                  console.log(res);
                  Swal.fire(
                    "Delete Successful!",
                    `${item.provider_name} has been deleted.`,
                    "success"
                  );
                  this.onSearch();
                }).catch((e)=>{
                  Swal.fire("Delete Failed!", `An Error Occured: ${e}`, "danger");
                  console.log("error while deleting a job",e);
                });
              }else{
                  return;
              }
          })
        } else {
          showAccessRestrictedModal();
        }
      },
      async onExport(){
        await this.onSearch("reset");
        if(this.totalRecord ==0){
          Swal.fire("Failed!", this.exportNullPrompt, "warning");
          return;
        }
        //var search_value_holder = this.searchValue;
        let params = Object.assign(
          // this.searchValue,
          {
            module: 'eload_provider',
            email: JSON.parse(localStorage.getItem('userData')).email,
            sort: this.searchValue.sort,
            orderDesc: this.searchValue.orderDesc,
            search: this.searchValue.search,
            searchField: this.searchValue.searchField,
            status: this.searchValue.status,
          });

        
        this.exportReport(params)
          .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
          .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
          console.log("value:",this.searchValue,params)
          // this.searchValue = search_value_holder;
      }
    },
    async mounted(){
      this.changeTitle({title: 'E-Load Provider'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'E-Load Provider', to: { name: 'E-Load Provider'} }
        ]
      });
      await this.onSearch();

      // get the module access for checking if user has create, read, update, and/or delete access
      await getModuleAccess('Products', 'eLoad', 'eLoad Provider')
        .then((access) => this.eloadProviderModule.access = access);
    }
  }
    
</script>

<template>
  <div><!-- outer div-->
      <div class="row">
          <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="row mb-3">
                        <div class="col-md-4 col-sm-4">
                            <div class="my-2">
                                <h5 class="card-title text-dark">
                                    <span class="fw-normal ms-lg-2"> {{ totalRecord }} </span> Record(s)
                                </h5>
                            </div>
                        </div>
                        <!-- end col record display--> 
                        <div class="col-md-8 col-sm-8">
                            <div class="d-flex justify-content-lg-end mb-lg-3">
                                <a class="btn btn-primary me-2" @click="addEloadProvider" v-if="eloadProviderModule.access.create">
                                  <i class="uil uil-plus me-1"></i> Add Provider
                                </a>
                                <a class="btn btn-secondary"
                                  @click="refresh"
                                    ><feather
                                    type="refresh-ccw"
                                    size="16"
                                    class="icon nav-icon"
                                    ></feather
                                    >&nbsp;&nbsp; Refresh</a
                                >
                            </div>
                        </div>
                        <!-- end col record display--> 
                        <div class="row">
                          <div class="w-auto mb-2">
                            <div class="d-flex mt-3 mb-3">
                              <div class="me-3">
                                <form class="d-flex" @submit.prevent="onSearch()">
                                  <b-form-group id="input-group-3" label-for="input-3">
                                    <b-form-select class="form-select rounded-0 rounded-start shadow-none w-200px" id="input-3" v-model="searchValue.searchField" :options="searchOptions"></b-form-select>
                                  </b-form-group>
                                  <b-form-group id="input-group-3" class="text-align-right" label-for="input-3">
                                    <template v-slot:description><div class="d-flex justify-content-end">Search for keyword</div></template>
                                    <b-form-input id="input-keyword" v-model="searchValue.search" class="rounded-0" style="width: auto"></b-form-input>
                                  </b-form-group>
                                </form>
                              </div>
                              <div class="me-3 ta-right">
                                <b-form-group label-for="reward-status" description="Filter by status">
                                  <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
                                    id="reward-status"
                                    v-model="searchValue.status"
                                    :options="statusOption"
                                  ></b-form-select>
                                </b-form-group>
                              </div>
                              <div class="me-3">
                                <b-form-group label="">
                                  <b-button variant="primary" type="button" @click="onSearch()" class="px-2 me-2">
                                    <i class='bx bx-search bx-fw'></i>
                                    Search
                                  </b-button>
                                  <a href="javascript:void(0);" class="btn btn-primary me-2" @click="onExport">
                                    <i class="uil uil-export me-1"></i>
                                    Export
                                  </a>
                                </b-form-group>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- end search div--> 


                        <div class="table-responsive">
                          <div class="table align-middle table-nowrap">
                            <b-table
                              :items="listRecord"
                              :fields="fields"
                              responsive="sm"
                              :current-page="searchValue.page"
                              :sort-by.sync="sortBy"
                              :sort-desc.sync="sortDesc"
                              @sort-changed="tableSorting"
                              class="table-check"
                            >
                              <template #cell(provider_name)="data">
                                <span class="text-body m-0 text-capitalize">
                                  <router-link :to="{ name: 'E-Load Provider Form', params: { id : data.item.id }}" 
                                  class="customer-name">
                                    {{ data.item.provider_name}}
                                  </router-link>
                                </span>
                              </template>
                              <template #cell(status)="data">
                                <span :class="`${data.item.status ?  'text-success': 'text-danger'}`">
                                  {{ data.item.status? "Active":"Inactive" }}
                                </span>
                              </template>
                              <template #cell(action)="data">
                                  <b-button variant="danger" class="p-1" @click="deleteProvider(data.item)"><i class="bx bx-trash bx-xs bx-fw"></i></b-button>
                              </template>
                              <template #cell(front_margin)="data">
                                {{ data.item.front_margin }} %
                              </template>
                              <template #cell(back_margin)="data">
                                {{ data.item.back_margin }} %
                              </template>
                              <template #cell(total_margin)="data">
                                {{ data.item.total_margin }} %
                              </template>
                            </b-table>
                          </div>
                        </div>
                        <div class="row g-0 text-center" v-if="totalRecord == 0">
                          <span>No data to display.</span>
                        </div>
                        <div class="row" v-if="totalRecord > 0">
                          <div class="col">
                            <div class="form-group row pull-left">
                              <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                              <div class="col-sm-6">
                                <b-form-group label-for="display-record">
                                  <b-form-select class="form-select shadow-none w-fit"
                                    id="display-record"
                                    v-model="searchValue.rows"
                                    :options="pageOptions"
                                    @change="onSearch('reset')"
                                  ></b-form-select>
                                </b-form-group>
                              </div>
                            </div>
                            <div
                              class="
                                dataTables_paginate
                                paging_simple_numbers
                                float-end
                              "
                            >
                              <b-pagination
                                v-if="totalRecord != 0 && totalRecord > searchValue.rows"
                                class="pagination-rounded"
                                v-model="searchValue.page"
                                :total-rows="totalRecord"
                                @input="onSearch()"
                                :per-page="searchValue.rows"
                              ></b-pagination>
                            </div>
                          </div>
                        </div>

                    </div>
                    <!-- end row -->
                </div>
                <!-- end card body -->
            </div>
            <!-- end card -->
          </div><!-- end col-lg-12 -->
      </div><!-- end of row-->
  </div> <!-- end of outer div-->
</template>